import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SsoInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if this is an SSO login request
    if (request.url.includes('/api/sso/login')) {
      if (!environment.production) {
        // console.log('SSO Interceptor: Processing SSO login request');
      }

      // Add specific headers for SSO requests
      const ssoRequest = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });

      return next.handle(ssoRequest);
    }

    return next.handle(request);
  }
}
